import { connect } from 'react-redux';
import {
  deleteCategory,
  updateCategorySubcategories,
  resetChecklist,
} from 'shared/store/actions/admission.actions';
import { AdmissionSectionListComponent } from './admission-section-list.component';
import { isNormalUser } from 'shared/store/selectors/user.selector';
import { admissionSelectChecklist } from 'src/store/actions/admission-viewer.actions';

const mapStateToProps = ({ application, admission, lang, auth }) => ({
  lang: lang.CONTENT_LIST,
  adminMode: application.adminMode,
  isHaveActiveChecklist: Object.keys(admission.activeChecklist).length,
  isUserIdentified: isNormalUser({ auth }),
});

const mapDispatchToProps = {
  deleteCategory,
  updateCategorySubcategories,
  admissionSelectChecklist,
  resetChecklist,
};

export const AdmissionSectionList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdmissionSectionListComponent);
